import { Button, Dialog, DialogContent, DialogTitle, Grid, Slide, Stack, Typography } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { useSnackbar } from "notistack";
import React, { ReactElement } from "react";
import { ApiError } from "../../Api/ApiError";
import { setStoreWorkingTime } from "../../Api/Store";
import { Time } from "../../Helper/Time";
import { WeekConditionsLongString } from "../../Helper/WeekConditions";
import { WorkPattern } from "../../Objects/WorkPattern";
import TimeInput from "../atoms/TimeInput";


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />
})

export interface StoreWorkingTimeEditDialogProps {
    workPattern?: WorkPattern
    onClose: (isEdit: boolean) => void
}

const StoreWorkingTimeEditDialog: React.FC<StoreWorkingTimeEditDialogProps> = ({
    workPattern,
    onClose,
}) => {
    let { enqueueSnackbar } = useSnackbar()


    const [open, setOpen] = React.useState<boolean>(false)
    const [newWorkPattern, setNewWorkPattern] = React.useState<WorkPattern>()

    const [openValue, setOpenValue] = React.useState<Time|null>(null)
    const [closeValue, setCloseValue] = React.useState<Time|null>(null)

    const doSubmit = React.useCallback( async () => {
        const controller = new AbortController()
        if( newWorkPattern && newWorkPattern.wrkptnset_id && newWorkPattern.week_conditions ) {
            setStoreWorkingTime({
                wrkptnset_id: newWorkPattern.wrkptnset_id,
                week_conditions: newWorkPattern.week_conditions,
                on_all: false,
                open: openValue,
                close: closeValue,
            }, {signal: controller.signal}).then(() => {
                enqueueSnackbar("保存しました", { variant: 'success' })
                onClose(true)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })

        }
        return () => {
            controller.abort()
        }
    }, [newWorkPattern, openValue, closeValue, enqueueSnackbar, onClose])

    React.useEffect(() => {
        setOpen(false)
        if( workPattern ) {
            setNewWorkPattern(workPattern)
            setOpenValue( workPattern.wrkptn_open ? workPattern.wrkptn_open : null )
            setCloseValue( workPattern.wrkptn_close ? workPattern.wrkptn_close : null )
            setOpen( true )
        }
    },[workPattern])

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={() => {
                onClose(false)
            }}
            fullWidth
        >
            <DialogTitle>営業時間を設定</DialogTitle>
            <DialogContent>
                {newWorkPattern &&
                    <>
                        <Grid container
                            alignItems="center"
                        >
                            <Grid item xs={12} sm={2}>
                                <Typography>{WeekConditionsLongString[newWorkPattern.week_conditions]}</Typography>
                            </Grid>
                            <Grid item xs={12} sm='auto'>
                                <TimeInput
                                    value={openValue}
                                    onChange={newValue => {
                                        console.log(newValue)
                                        setOpenValue(newValue)
                                    }}
                                />
                            </Grid>
                            <Grid item
                                sx={{
                                    mx: 2,
                                    textAlign: "center"
                                }}
                                xs={12}
                                sm='auto'
                            >
                                {"～"}
                            </Grid>
                            <Grid item xs={12} sm='auto'>
                                <TimeInput
                                    value={closeValue}
                                    onChange={newValue => {
                                        console.log(newValue)
                                        setCloseValue(newValue)
                                    }}
                                />
                            </Grid>
                            <Grid item
                                sx={{
                                    mx: 0,
                                    mt: 2,
                                    marginLeft: "auto",
                                    textAlign: "center",
                                }}
                                xs={12}
                            >
                                <Stack
                                    spacing={1}
                                    direction="row"
                                    justifyContent="right"
                                >
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            doSubmit()
                                        }}
                                    >保存</Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            onClose(false)
                                        }}
                                    >キャンセル</Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </>
                }
            </DialogContent>
        </Dialog>
    );
}

export default StoreWorkingTimeEditDialog